<div class="unauth-container">
    <h2>Unauthorized</h2>
    <p>You don’t have permission to view this page.</p>
  </div>
  